module.exports = __webpack_public_path__ + "static/img/guide_3_2_1.2638af9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guide_3_2_1.jpg
// module id = neui
// module chunks = 1